import { render, staticRenderFns } from "./RemoveFromSegment.vue?vue&type=template&id=3d586181&"
import script from "./RemoveFromSegment.vue?vue&type=script&lang=js&"
export * from "./RemoveFromSegment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports